<template>
    <div>
        <el-dialog :title="$t('printing')" :visible.sync="print_modal.show" width="30%" :beforeClose="cancelPrint" center append-to-body>
            <div style="text-align: center;">
                <h3>{{ $t('show.generating_pdf') }}</h3>

                <br/>
                <br/>

                <div v-if="isComplete">
                  <i class="fal fa-check fa-4x" style="color: green;"></i>
                </div>
                <div v-else :style="isComplete ? '': 'display: false;'">
                  <i class="fal fa-spinner fa-pulse fa-4x" :style="{ display: isComplete ? 'hidden' : ''}"></i>

                  <br/>
                  <br/>

                  <h5>{{ $t('show.please_wait') }}</h5>

                </div>


                <br/>
                <br/>

                <h4>{{ print_modal.message }}</h4>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelPrint">
                    <span v-if="show_cancel_btn">{{ $t('show.cancel') }}</span>
                    <span v-else>{{ $t('close') }}</span>
                </el-button>

                <el-button v-if="isComplete" @click="downloadClicked(print_modal.download_url)">
                    <i class="fa fa-download"></i>
                </el-button>


            </span>
        </el-dialog>

        <el-dialog
            :title="$t('choose_format')"
            :visible.sync="print_modal_multiple"
            width="50%"
            center
            append-to-body
            top="5vh"
        >
            <el-table
                :data="builds"
                style="width: 100%"
            >
                <el-table-column
                    :label="$t('progress')"
                    width="90"
                    align="center"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 'completed'">
                            <i class="fal fa-check" style="font-size: 24px; color: green;"></i>
                        </span>

                        <span v-if="scope.row.status !== 'completed'" :style="scope.row.status !== 'completed' ? 'display: false;' : ''">
                            <i class="fal fa-spinner fa-pulse" style="font-size: 24px;"></i>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="format.title"
                    :label="$t('format')"
                >
                </el-table-column>

                <el-table-column
                    :label="$t('status')"
                    width="200"
                >
                    <template slot-scope="scope">
                        {{ scope.row.message }}
                    </template>
                </el-table-column>

                <el-table-column width="100">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            type="success"
                            @click="downloadClicked(scope.row.links.download)"
                            v-if="!scope.row.hasOwnProperty('direct_print')"
                            :disabled="scope.row.status !== 'completed'"
                        >
                            {{ $t('download') }}
                        </el-button>
                      <el-button @click="downloadClicked(scope.row.links.download)" v-if="scope.row.hasOwnProperty('direct_print')" :disabled="scope.row.status !== 'completed'">
                         <i class="fa fa-download"></i>
                      </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click="print_modal_multiple = false">
                    {{ $t('close') }}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import Axios from 'axios';
    import _ from 'lodash';

    export default {
        props: ['search_filter', 'structure', 'items', 'list_id', 'list_title'],
        data() {
            return {
                show_cancel_btn: true,
                print_modal_multiple: false,
                show_multiple_formats_print: false,
                print_modal: {
                    show: false,
                    message: '',
                    status: null,
                    download_url: null,
                },
                active_print_step: 0,
                sort_field: 'title',
                sort_order: 'asc',
                current_sort: 'title',
                base_url: 'https://api.brandsafe.no/v2/worklists',
                print_cancelled: false,
                builds: [],
            }
        },

        computed: {
          isComplete() {
            return this.print_modal.status === 'complete';
          }
        },

        methods: {
            getToken() {
                return this.$cookies.get('bs_token');
            },

            printAll(selected = false, in_stock = false, formats = null) {
                this.print_modal.status = null;
                this.print_modal.download_url = null;

                let data = {
                    sort_field: this.current_sort,
                    sort_order: this.sort_order
                }

                if (selected && this.items && this.items.length) {
                    this.$set(data, 'items', this.items);
                }

                if (formats && formats.length) {
                    this.$set(data, 'formats', formats);
                }

                Axios.post(this.base_url + '/lists/' + this.list_id + '/builds' + ((in_stock) ? '?instock=1' : ''), data, { headers: { Authorization: 'Bearer ' + this.getToken() } }).then(response => {
                    if (response.data.hasOwnProperty('errors') && response.data.errors.length) {
                        response.data.errors.forEach(error => {
                            this.$notify({
                                title: this.$t('messages.info'),
                                message: this.$t(error),
                                type: 'info'
                            });
                        });

                        return false;
                    }

                    this.builds = response.data.data;

                    if (this.builds.length > 1) {
                        this.print_modal_multiple = true;

                        this.builds.forEach((build, index) => {
                            this.handleMultipleDownload(index);
                        });
                    }

                    else if (this.builds.length == 1) {
                        this.builds.forEach(build => {
                            this.print_modal.show = true;
                            this.print_cancelled = false;
                            this.getDownload(build.links.self);
                        });
                    }
                }, error => {
                    console.log('error')
                });
            },

            handleMultipleDownload(build_index) {
                let self = this;

                Axios.get(this.builds[build_index].links.self, { headers: { 'Authorization': 'Bearer ' + this.getToken() } }).then((response) => {
                    this.$set(this.builds[build_index].links, 'download', response.data.data.links.download);

                    if (response.data.data.status === 'error') {
                        this.$set(this.builds[build_index], 'status', response.data.data.status);
                    }
                    else if (response.data.data.status === 'completed') {
                        let print_url = response.data.data.links.download;
                        print_url = print_url.replace('/download', '/prints');

                        Axios.post(print_url, null, { headers: { 'Authorization': 'Bearer ' + this.getToken() } }).then(
                            (resp) => {
                              this.$set(this.builds[build_index], 'direct_print', true);
                              this.$set(this.builds[build_index], 'message', this.$t('show.pdf_sending_to_printer'));

                              const saved = this.saveNotification(resp.data.data, build_index)

                              return this.getPrintStatus(resp.data.data.links.self, { value: build_index });
                            },
                            (error) => {
                              this.$set(this.builds[build_index], 'message', this.$t('completed1'));
                              this.$delete(this.builds[build_index], 'direct_print');
                              this.$set(this.builds[build_index], 'status', response.data.data.status);
                              this.$set(this.builds[build_index].links, 'download', response.data.data.links.download);
                            }
                        );
                    }

                    else {
                        this.$set(this.builds[build_index], 'status', response.data.data.status);
                        setTimeout(function () {
                            self.handleMultipleDownload(build_index);
                        }, 500);
                    }
                }, (error) => {
                    console.log(error);
                });
            },

            getDownload(url) {
                let self = this;

                if (this.print_cancelled) {
                    return false;
                }

                Axios.get(url, { headers: { 'Authorization': 'Bearer ' + this.getToken() } }).then((response) => {
                    let data = response.data.data;

                    self.print_modal.message = response.data.data.message;

                    if (typeof self.print_modal.message === "string") {
                        self.print_modal.message = self.print_modal.message.replace('Building page ', this.$t('show.building_template'));
                        self.print_modal.message = self.print_modal.message.replace('Preparing page ', this.$t('show.preparing_template'));
                        self.print_modal.message = self.print_modal.message.replace('Pdf complete', this.$t('show.pdf_complete'));
                    }

                    if (response.data.data.status === 'completed') {
                        let print_url = response.data.data.links.download;
                        print_url = print_url.replace('/download', '/prints');

                        Axios.post(print_url, null, { headers: { 'Authorization': 'Bearer ' + this.getToken() } }).then(
                            (response) => {
                              self.show_cancel_btn = false;
                              self.print_modal.message = this.$t('show.pdf_sending_to_printer')

                              const saved = this.saveNotification(response.data.data)

                              return this.getPrintStatus(response.data.data.links.self);
                            },
                            (error) => {
                              self.print_modal.show = false;
                              window.open(this.formatUrl(response.data.data.links.download), '_self');
                            }
                        );
                    }

                    else if (response.data.data.status === 'error') {
                        console.log('error');
                    }

                    else {
                        setTimeout(function () {
                            self.getDownload(response.data.data.links.self);
                        }, 500);
                    }
                }, (error) => {
                    console.log(error);
                });
            },

          saveNotification(print, build_index=0) {
            if (!print) return false;

            let account = localStorage.getItem('active_account')
            if (typeof account === 'string') {
              account = JSON.parse(account)
            }

            if (!account || !account['department'] || !account['department']['id']) {
              return false
            }

            let user = localStorage.getItem('user')
            if (typeof user === 'string') {
              user = JSON.parse(user)
            }

            if (!user || !user['id']) {
              return false
            }

            if(build_index<0 || !Array.isArray(this.builds) || this.builds.length===0 || this.builds.length<build_index){
              return false;
            }

            const build = this.builds[build_index];
            if(!build){
              return false
            }

            const {id: print_id, status: print_status, links: print_links} = print;
            let notificationKey = `bs_notification_${account.department.id}_${user.id}`
            let notifications = window.localStorage.getItem(notificationKey);
            if (typeof notifications === "string") {
              try {
                notifications = JSON.parse(notifications);
              } catch (err) {
                notifications = [];
              }
            }

            if (!Array.isArray(notifications)) {
              notifications = []
            }

            const listTitle = this.list_title
            const itemCount = (Array.isArray(this.items))?this.items.length:''
            const templateFormat = _.get(build, 'format.title')
            const notificationLabel = `${listTitle}`
            const notificationDescription = `${templateFormat}, ${itemCount}`;

            const notification = {
              timestamp: Date.now(),
              id: print_id,
              type: 'print',
              label: notificationLabel,
              description: notificationDescription,
              print: {
                id: print_id, status: print_status, links: print_links,
              }
            }

            const notificationIndex = notifications.findIndex(n => n.id === notification.id);
            if (notificationIndex >= 0) {
              notifications[notificationIndex] = notification;
            } else {
              notifications.push(notification);
            }

            window.localStorage.setItem(notificationKey, JSON.stringify(notifications));

            const event = new CustomEvent('bs_notification', {
              detail: {
                key: notificationKey,
                notification: notification
              }
            });

            window.dispatchEvent(event);

            return true;
          },

            async getPrintStatus(url, multi_print_id) {
              const response = await Axios.get(url, {headers: {'Authorization': 'Bearer ' + this.getToken()}});

              if(!_.isNull(response.data.data.failed_at)) {
                if(multi_print_id && multi_print_id.value !== undefined) {
                  this.$set(this.builds[multi_print_id.value], 'message', this.$t('show.pdf_failed_to_print'));
                  this.$set(this.builds[multi_print_id.value], 'status', this.$t('failed'));
                  this.$delete(this.builds[multi_print_id.value], 'direct_print');
                } else {
                  this.print_modal.message = this.$t('show.pdf_failed_to_print')

                  window.open(this.formatUrl(response.data.data.links.download), '_self');
                }
                return true;
              }

              if(!_.isNull(response.data.data.completed_at)) {
                if(multi_print_id && multi_print_id.value !== undefined) {
                  this.$set(this.builds[multi_print_id.value], 'message', this.$t('show.pdf_print_complete'));
                  this.$set(this.builds[multi_print_id.value], 'status', 'completed');
                } else {
                  this.print_modal.message = this.$t('show.pdf_print_complete');
                  this.$set(this.print_modal, 'status', 'complete');
                  this.$set(this.print_modal, 'download_url', response.data.data.links.download);
                }
                return true;
              }

              setTimeout(() => this.getPrintStatus(url, multi_print_id), 2000);
            },

            downloadClicked(url) {
                window.open(this.formatUrl(url), '_self');
            },

            formatUrl(url) {
                if (!url) {
                    return url;
                }

                if (url.indexOf('//api.brandsafe.no') !== -1) {
                  url += (url.indexOf('?') !== -1) ? '&' : '?';
                  return url + 'token=' + this.getToken();
                }

                return url;
            },

            cancelPrint() {
                this.active_print_step = 0;
                this.print_modal.show = false;
                this.print_cancelled = true;
            },
        }
    }
</script>
